import Axios from "axios";
import QueryOptions from "../sal-ui/QueryOptions";
import PagedResult from "./PagedResult";
import VulSourceHealthReportDefinition from "../domain/VulSourceHealthReportDefinition";

class VulSourceHealthReportDefinitionService {

    readonly basePath = "/vul-source-health-report-definitions";

    public add(definition: VulSourceHealthReportDefinition): Promise<string> {
        return Axios.post(`${this.basePath}`, definition).then(value => value.data.id)
    }

    public update(id: string, definition: VulSourceHealthReportDefinition): Promise<void> {
        return Axios.put(`${this.basePath}/${id}`, definition);
    }

    public get(id: string): Promise<VulSourceHealthReportDefinition> {
        return Axios.get(`${this.basePath}/${id}`)
            .then(value => VulSourceHealthReportDefinition.fromPOJO(value.data))
    }

    public delete(definition: VulSourceHealthReportDefinition): Promise<void> {
        return Axios.delete(`${this.basePath}/${definition.id}`);
    }

    public getList(queryOptions: QueryOptions): Promise<PagedResult<VulSourceHealthReportDefinition>> {
        return Axios.get(`${this.basePath}?${queryOptions.toQueryParams()}`)
            .then(value => {
                const objectList: VulSourceHealthReportDefinition[] = [];

                value.data.data.forEach((objectJson: object) => {
                    objectList.push(VulSourceHealthReportDefinition.fromPOJO(objectJson));
                });

                return new PagedResult(value.data.total, objectList);
            })
    }

}

export default VulSourceHealthReportDefinitionService;
